import { html } from 'lit';
import { KiAppWWP } from '@kisters/wiski-web/components';
import { Mix } from '@kisters/wcp-base/common';
import { customElement } from 'lit/decorators.js';
import { SM, ViewPort } from '@kisters/wcp-base/decorators';
import { getConfig } from '@kisters/wcp-base/app';
import '@kisters/wiski-web/components/ki-ww-start/ki-ww-start';
import dayjs from 'dayjs';
import style from './ww-app.css.js';

@customElement('ww-app')
export default class WWApp extends Mix(KiAppWWP) {
  static styles = [KiAppWWP.styles, style];

  _renderHeader() {
    const config = getConfig();
    return ViewPort.size === SM
      ? this._renderHeaderMobile(config)
      : this._renderHeaderDesktop(config);
  }

  _renderHeaderMobile(config) {
    return html`
      <div class="header">
        <ki-icon-btn
          icon="ki ki-bars"
          class="toggle-btn"
          @click="${this.toggleSideBar}"
        ></ki-icon-btn>
        <div class="logo-left mobile">
          <a href=${config.leftLogoLink} target="_blank">
            <img alt="Alberta Logo" src="./images/logo_left.png" />
          </a>
        </div>
        <div class="app-name mobile">GOWN Monitoring Data</div>
        ${config?.globalComment ? this._renderGlobalComment() : ''}
      </div>
    `;
  }

  _renderHeaderDesktop(config) {
    return html`
      <div class="header">
        <div class="logo-left">
          <a href=${config.leftLogoLink} target="_blank">
            <img alt="Alberta Logo" src="./images/logo_left.png" />
          </a>
        </div>
        ${config?.globalComment ? this._renderGlobalComment() : ''}
        <div class="app-name">
          Groundwater Observation Well Network (GOWN), Monitoring Data
        </div>
      </div>
      <div class="nav">${ViewPort.size === SM ? '' : this._renderMenu()}</div>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  _renderFooter() {
    return html` <div slot="footer" class="footer">
      <div class="footer-mobile">
        <span> © 2022 KISTERS AG </span>
        <div class="tooltip">
          Disclaimer
          <span class="tooltiptext">
            *Disclaimer* The Government of Alberta assumes no responsibility for
            the accuracy or completeness of these data and any use of them is
            entirely at your own risk.
          </span>
        </div>
        <a
          href="mailto:AEP.GOWNinfo@gov.ab.ca"
          style="text-decoration: none; color: white; font-weight: bold"
          >Contact</a
        >
      </div>

      <div class="footer-left">© 2022 KISTERS AG | All rights reserved</div>
      <div class="footer-right">
        *Disclaimer* The Government of Alberta assumes no responsibility for the
        accuracy or completeness of these data and any use of them is entirely
        at your own risk.
        <br />
        For technical enquires about this web page please contact Alberta
        Environment and Protected Areas - Data Management Section - Groundwater
        Information at
        <a
          href="mailto:AEP.GOWNinfo@gov.ab.ca"
          style="text-decoration: none; color: white; font-weight: bold"
          >AEP.GOWNinfo@gov.ab.ca</a
        >
      </div>
    </div>`;
  }
}
